import { ErasureStatus, SarStatus } from '@today/types'

/** Shared presentation helpers of the compliance pages (TO-232 compliance-admin-ui). */

/** Every list asks for 20 rows per page (REQ-202, REQ-205). */
export const PAGE_SIZE = '20'

/** A request in these statuses refreshes every 5 seconds (REQ-203, REQ-205). */
export const REFRESH_MS = 5000
export const POLLED_ERASURE_STATUSES: ReadonlySet<ErasureStatus> = new Set([
	ErasureStatus.PREVIEW_PENDING,
	ErasureStatus.ERASING,
])
export const POLLED_SAR_STATUS = SarStatus.COLLECTING

/** A date for display in the active language; `—` when absent. */
export const formatDate = (iso: string | null, language: string, withTime = false): string =>
	iso
		? new Intl.DateTimeFormat(
				language,
				withTime ? { dateStyle: 'medium', timeStyle: 'short' } : { dateStyle: 'medium' },
			).format(new Date(iso))
		: '—'

/** Opens a short-lived download URL in a new tab; it is never stored (compliance-admin-ui Security). */
export const openDownload = (url: string): void => {
	window.open(url, '_blank', 'noopener')
}

/** `page` + `limit` + the optional status filter, in the API's `filters[key]` form. */
export const listParams = (page: number, status: string): Record<string, string> => ({
	page: String(page),
	limit: PAGE_SIZE,
	...(status ? { 'filters[status]': status } : {}),
})

/** "All" plus one option per status value. */
export const statusOptions = (values: readonly string[], label: (value: string) => string, all: string) => [
	{ id: '', label: all },
	...values.map((value) => ({ id: value, label: label(value) })),
]
